import { useEffect } from 'react';

/** Закрывает модальное окно по Escape, пока оно открыто. */
export const useEscapeKey = (active: boolean, onClose: () => void) => {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [active, onClose]);
};
